module.exports = __webpack_public_path__ + "static/media/WBN_TIP_H.cac1781c.png";